import { __awaiter, __generator } from "tslib";
require('./env');
import React from 'react';
import { app, renderAsApp } from '@ekuaibao/whispered';
import { setGlobalDeepKeys, setStoreFeatbitEnable } from '@ekuaibao/store';
import Patches from './patches';
import { run } from '@ekuaibao/mfe-dock';
import './config';
import { postStoreInitialized } from './postStoreInitialized';
require('./_plugins');
import systemLimitLogout from './systemLimitLogout';
import { enableBillRenderOptimization, enableFMPOptimization } from '../lib/featbit';
import { startPrefetch } from './prefetchApis';
import { filterFromUrl } from '../lib/lib-util';
import { hostFmpDebug, } from './deferred-mfe';
var isFmpOptimizationEnabled = function () { return enableFMPOptimization() || filterFromUrl('debugger'); };
var loadMfePlugin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                performance.mark('mfeLoadStart');
                return [4, run({
                        onChanged: function () {
                            var _a, _b;
                            (_a = window.ekbLoader) === null || _a === void 0 ? void 0 : _a.setExtendRes(((_b = window.MFE_REGISTRY_LIST) === null || _b === void 0 ? void 0 : _b.length) || 0);
                        },
                        onMfeChanged: function (event) {
                            var _a;
                            (_a = window.ekbLoader) === null || _a === void 0 ? void 0 : _a.resLoaded(true, event);
                        }
                    })];
            case 1:
                _a.sent();
                performance.mark('mfeLoadEnd');
                return [3, 3];
            case 2:
                ex_1 = _a.sent();
                console.error('index.v0.tsx:callback MfeDock.run()', ex_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
var mfeLoadPromise = null;
export var preloadMfePlugin = function () {
    if (!mfeLoadPromise) {
        hostFmpDebug('preloadMfePlugin start full load');
        mfeLoadPromise = loadMfePlugin();
    }
    return mfeLoadPromise;
};
export var startMfeLoad = function () {
    if (mfeLoadPromise) {
        hostFmpDebug('startMfeLoad skipped, mfe promise already exists');
        return;
    }
    hostFmpDebug('startMfeLoad called');
    mfeLoadPromise = loadMfePlugin();
};
export var startFmpPrefetch = function () {
    if (!isFmpOptimizationEnabled()) {
        return;
    }
    startPrefetch();
    hostFmpDebug('startPrefetch called');
};
var handleStoreOptimization = function () {
    setStoreFeatbitEnable(enableBillRenderOptimization === null || enableBillRenderOptimization === void 0 ? void 0 : enableBillRenderOptimization());
    if (enableBillRenderOptimization === null || enableBillRenderOptimization === void 0 ? void 0 : enableBillRenderOptimization()) {
        setGlobalDeepKeys(['userInfo', 'allCurrencyRates', 'userinfo', 'userInfoData', 'user', 'validateError']);
    }
};
export function callback() {
    return __awaiter(this, void 0, void 0, function () {
        var dom;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handleStoreOptimization();
                    performance.mark('appRenderStart');
                    hostFmpDebug('callback start');
                    return [4, (mfeLoadPromise || loadMfePlugin())];
                case 1:
                    _a.sent();
                    hostFmpDebug('critical mfe await complete');
                    mfeLoadPromise = null;
                    performance.mark('appCallbackStart');
                    return [4, app.callback(function (children) { return React.createElement(Patches, null, children); })];
                case 2:
                    dom = _a.sent();
                    performance.mark('appCallbackEnd');
                    hostFmpDebug('app.callback resolved');
                    performance.mark('renderAsAppStart');
                    return [4, renderAsApp(dom)];
                case 3:
                    _a.sent();
                    performance.mark('renderAsAppEnd');
                    hostFmpDebug('renderAsApp resolved');
                    postStoreInitialized();
                    systemLimitLogout();
                    performance.mark('appRenderEnd');
                    return [2];
            }
        });
    });
}
export { app };
export default app;
